var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 11,
    viewBox: "0 0 96 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81203 0H20.2105L15.3985 10.5865H0L4.81203 0Z",
    fill: "#E30015"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7593 0H39.1578L34.3458 10.5865H18.9473L23.7593 0Z",
    fill: "#E30015"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7066 0H58.1051L53.293 10.5865H37.8945L42.7066 0Z",
    fill: "#E30015"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6538 0H77.0523L72.2403 10.5865H56.8418L61.6538 0Z",
    fill: "#E30015"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6021 0H96.0006L91.1885 10.5865H75.79L80.6021 0Z",
    fill: "#D0D0D0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.4f39961df68d1d67eeb6851fbff984bb.svg";
export { ForwardRef as ReactComponent };